// extracted by mini-css-extract-plugin
module.exports = {"layout":"reveal_layout__1FbKN"};